import React, { useMemo } from "react";
import constant from "../../../utils/constant";
import moment from "moment";
import {
  AppPage,
  MimaOptionMenu,
  MimaTable,
  MimaText,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";
import { AnimatePresence } from "framer-motion";
import {
  RefundInstantPaymentContainer,
  UpdateInstantPaymentContainer,
  VerifyInstantPaymentContainer,
  ViewMoreInstantOrderInfoContainer,
} from "../../../containers";

const MoneyExExpressOrders = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  closeModal,
  singleItem,
  optionHandler,
  options,
  openModal,
  modalConstants,
}) => {
  const expressOrdersTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.moneyExInstantOrders || [];
    }
    return [];
  }, [data]);

  const expressOrdersTableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YY HH:mm A")}</span>;
      },
    },
    // {
    //   Header: "Exchange",
    //   accessor: "from",
    //   Cell: ({ cell }) => {
    //     const from = cell.value;
    //     const to = cell.row.original.to;
    //     return (
    //       <span>
    //         Changing {from} to {to}
    //       </span>
    //     );
    //   },
    // },
    {
      Header: "User Transactions",
      accessor: "buyer",
      Cell: ({ cell }) => {
        const user = cell.value;
        const username = user.username;
        const fullname = `${user.firstname} ${user.lastname}`;
        const orders = user.orders;
        // const avgCompletionRate = user.avgCompletionRate;
        // const avgCompletionTime = user.avgCompletionTime;

        const row = cell.row.original;
        const buyerDebitValue = row.buyerDebitValue.amount;
        const currencyCode = row.buyerDebitValue.currencyCode;
        const formattedBuyerDebitValue =
          amountFormatter(currencyCode).format(buyerDebitValue);
        const buyerCreditValue = row.buyerCreditValue.amount;
        const creditCurrencyCode = row.from;
        const formattedBuyerCreditValue =
          amountFormatter(creditCurrencyCode).format(buyerCreditValue);

        const buyerStatus = row.buyerStatus;

        return (
          <div>
            <MimaText variant="smallBold">
              {fullname} - {username}
            </MimaText>
            <MimaText variant="small">{orders} orders</MimaText>
            {/* <div style={{ display: "flex", gap: "1rem" }}>
              <MimaText variant="small">{avgCompletionRate}% </MimaText>
              <MimaText variant="small">{avgCompletionTime}mins </MimaText>
            </div> */}

            <MimaText variant="small" mt={1}>
              Pays <span className="font__700">{formattedBuyerDebitValue}</span>
            </MimaText>
            <MimaText variant="small" mb={1}>
              Receives{" "}
              <span className="font__700">{formattedBuyerCreditValue}</span>
            </MimaText>
            <div
              className={`status  ${buyerStatus === "PAID" ? "status__green" : buyerStatus === "REVERSED" ? "status__grey" : buyerStatus === "FALSE-PAYMENT" ? "status__red" : "status__dark__yellow"}`}
            >
              {buyerStatus}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Receiver Bank Info",
      accessor: "buyerBankInfo",
      Cell: ({ cell }) => {
        const bank = cell.value;
        const accountName = bank.accountName;
        const accountNumber = bank.accountNumber;
        const bankName = bank.bank;
        const isForeign = bank.foreign.data?.length > 0 ? true : false;
        const foreignBank = bank?.foreign?.data || [];
        const paymentType = bank?.foreign?.paymentType;
        const NgBank = () => {
          return (
            <div>
              <MimaText variant="smallBold">Bank Transfer</MimaText>
              <MimaText variant="small">{accountNumber}</MimaText>
              <MimaText variant="small">{accountName}</MimaText>
              <MimaText variant="small">{bankName}</MimaText>
            </div>
          );
        };
        const FxBank = () => {
          return (
            <div>
              <MimaText variant="smallBold">{paymentType}</MimaText>
              {foreignBank.map((x, i) => (
                <MimaText variant="small" key={i}>
                  {x.label} - {x.value}
                </MimaText>
              ))}
            </div>
          );
        };

        return <div>{isForeign ? <FxBank /> : <NgBank />}</div>;
      },
    },
    {
      Header: "Reference Code",
      Cell: ({ cell }) => {
        const referenceCode = cell.row.original.referenceCode;
        return <span>{referenceCode}</span>;
      },
    },
    {
      Header: "Mima Transaction",
      Cell: ({ cell }) => {
        const row = cell.row.original;
        const mimaCreditValue = row.mimaCreditValue.amount;
        const currencyCode = row.mimaCreditValue.currencyCode;
        const formattedMimaCreditValue =
          amountFormatter(currencyCode).format(mimaCreditValue);
        const mimaDebitValue = row.mimaDebitValue.amount;
        const debitCurrencyCode = row.mimaDebitValue.currencyCode;
        const formattedMimaDebitValue =
          amountFormatter(debitCurrencyCode).format(mimaDebitValue);

        const mimaStatus = row.mimaStatus;

        return (
          <div>
            <MimaText variant="small">
              Pays <span className="font__700">{formattedMimaDebitValue}</span>
            </MimaText>
            <MimaText variant="small" mb={1}>
              Receives{" "}
              <span className="font__700">{formattedMimaCreditValue}</span>
            </MimaText>
            <div
              className={`status  ${mimaStatus === "PAID" ? "status__green" : mimaStatus === "REVERSED" ? "status__grey" : mimaStatus === "FAILED" ? "status__red" : "status__dark__yellow"}`}
            >
              {mimaStatus}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const buyerStatus = item?.buyerStatus;
        const adminBuyerPaymentStatus = item?.adminBuyerPaymentStatus;
        const status = item?.status;
        return (
          <MimaOptionMenu
            options={options(buyerStatus, adminBuyerPaymentStatus, status)}
            onOptionSelected={(option) => {
              optionHandler(option, item);
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Money-Ex Express Orders">
      <MimaTable
        tableData={expressOrdersTableData}
        tableColumns={expressOrdersTableColumns}
        searchPlaceholder="Search Money-Ex Express Orders"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
      {openModal !== modalConstants.Close && (
        <div className="modal">
          <AnimatePresence>
            {openModal === modalConstants.ViewBuyerInfo && (
              <ViewMoreInstantOrderInfoContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.VerifyBuyerPayment && (
              <VerifyInstantPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.UpdateBuyerPayment && (
              <UpdateInstantPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.RefundBuyerPayment && (
              <RefundInstantPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default MoneyExExpressOrders;
